import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getTrackingMapLocation = {
  name: "getTrackingMapLocation" as const,
  input: z.object({ orderId: zExt.objectId(), shipmentId: z.string() }),
  output: z.object({
    geo: z.object({ latitude: z.number(), longitude: z.number() }).nullable(),
  }),
};
